import { useAuthContext } from "src/auth/AuthContext";
import TransfersForm from "./TransfersForm";
import { transferService } from "src/service/TransferService";
import { useParams } from "react-router-dom";

const TransfersEdit = () => {
  const { user } = useAuthContext();
  const { id } = useParams();
  return (
    <TransfersForm
      transferId={parseInt(id ?? "-1")}
      organizationId={user?.data?.organizationId}
      onSubmit={(ps) => transferService.update(ps).then(() => {})}
      header="Transfer Bearbeiten"
    />
  );
};

export default TransfersEdit;
